export default "<a (click)=\"change()\">{{'word.language' | translate}}: {{currentLanguage}}</a>\n"